import { render, staticRenderFns } from "./CountryFlag.vue?vue&type=template&id=0d80ab62&scoped=true"
import script from "./CountryFlag.vue?vue&type=script&lang=js"
export * from "./CountryFlag.vue?vue&type=script&lang=js"
import style0 from "./CountryFlag.vue?vue&type=style&index=0&id=0d80ab62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d80ab62",
  null
  
)

export default component.exports